import { render, staticRenderFns } from "./WechatAccountUnify.vue?vue&type=template&id=0a22576e"
import script from "./WechatAccountUnify.vue?vue&type=script&lang=js"
export * from "./WechatAccountUnify.vue?vue&type=script&lang=js"
import style0 from "./WechatAccountUnify.vue?vue&type=style&index=0&id=0a22576e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports